import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelperService } from 'src/app/services/helper.service';
import { HelpInfoMonitorComponent } from '../help-info-monitor/help-info-monitor.component';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss']
})
export class HelpMenuComponent implements OnInit {
  @Input() helpInfoPayload:any;
  selectedOption: string = '';

  constructor(private helpService:HelperService,private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  onOptionClick(option: string) {
    this.selectedOption = option;
    console.log('Option clicked:', this.selectedOption, "helpInfoPayload",this.helpInfoPayload);
    this.helpService.getHelpInfoPath( this.helpInfoPayload).subscribe({
      next:(res:any)=>{
        console.log("res",res[0][this.selectedOption]);
        if(res) {
          let data = {
            payload:res[0][this.selectedOption],
            type:this.selectedOption
          }
          this.openDialog(data);
        }
        //this.getHelpInfS3Url(res[0][this.selectedOption]);
      }}
    )
  }

  openDialog(data:any):void {
    this.dialog.open(HelpInfoMonitorComponent,{
      data:{payload:data.payload,type:data.type},
      width: '80%',
      height: '80%',
    });
  }
}
